import type { ReactNode } from 'react'
import type { AuthLayoutPanel } from '@/widgets/auth-layout'
import { Header } from '@/widgets/header'
import { designTokens } from '@/shared/lib/design-tokens'
import type {
  AuthBadgeLayout,
  AuthBadgeSurfaceVariant,
  AuthBadgeTextVariant,
} from './registration-badge'
import { AuthBadge } from './registration-badge'

const registrationMobileTokens = designTokens.components.registration.mobile
const mobileBadgeTokens = registrationMobileTokens.badges

const mobileBadges = [
  {
    label: 'маркетологи',
    textVariant: 'mobileBase',
    surfaceVariant: 'mobile',
    layout: mobileBadgeTokens.marketersLeft,
  },
  {
    label: 'маркетологи',
    textVariant: 'mobileBase',
    surfaceVariant: 'mobile',
    layout: mobileBadgeTokens.marketersRight,
  },
  {
    label: 'владельцы бизнеса',
    textVariant: 'mobileBase',
    surfaceVariant: 'mobile',
    layout: mobileBadgeTokens.businessOwners,
  },
  {
    label: 'продакты',
    textVariant: 'mobileBase',
    surfaceVariant: 'mobile',
    layout: mobileBadgeTokens.products,
  },
  {
    label: 'предприниматели',
    textVariant: 'mobileWide',
    surfaceVariant: 'mobile',
    layout: mobileBadgeTokens.entrepreneurs,
  },
  {
    label: 'CPO',
    textVariant: 'mobileBase',
    surfaceVariant: 'mobile',
    layout: mobileBadgeTokens.cpo,
  },
] satisfies Array<{
  label: string
  textVariant: AuthBadgeTextVariant
  surfaceVariant: AuthBadgeSurfaceVariant
  layout: AuthBadgeLayout
}>

type RegistrationPageMobileProps = {
  panel: AuthLayoutPanel
  renderAuthLayout: (variant: 'desktop' | 'mobile') => ReactNode
}

export function RegistrationPageMobile({ panel, renderAuthLayout }: RegistrationPageMobileProps) {
  const showDecor = panel === 'email'
  const mobileLogoSize = panel === 'email' ? 'large' : 'default'
  const mobileHeader =
    panel === 'email'
      ? registrationMobileTokens.headerEmail
      : registrationMobileTokens.headerCompact
  const mobileTopAreaMinHeight =
    panel === 'email'
      ? `clamp(280px, 38dvh, ${registrationMobileTokens.topAreaMinHeightEmail})`
      : registrationMobileTokens.topAreaMinHeightTall

  return (
    <div className="relative flex min-h-[100dvh] w-full flex-col items-center lg:hidden">
      <div
        className="relative w-full flex-1"
        style={{
          minHeight: mobileTopAreaMinHeight,
          maxWidth: registrationMobileTokens.frame.width,
        }}
      >
        <div
          className="absolute"
          style={{
            left: '50%',
            top: mobileHeader.y,
            width: mobileHeader.width,
            height: mobileHeader.height,
            transform: 'translateX(-50%)',
          }}
        >
          <Header
            logoSize={mobileLogoSize}
            paddingTop={
              mobileLogoSize === 'large'
                ? registrationMobileTokens.headerPaddingTopLarge
                : undefined
            }
          />
        </div>
        {showDecor
          ? mobileBadges.map((badge) => (
              <AuthBadge key={`${badge.label}-${badge.layout.x}-${badge.layout.y}`} {...badge} />
            ))
          : null}
      </div>
      <div className="mt-auto w-full">{renderAuthLayout('mobile')}</div>
    </div>
  )
}
